const GET_PRODUCT_REQUEST = 'getProduct/request';
const GET_PRODUCT_SUCCESS = 'getProduct/success';
const GET_PRODUCT_ERROR = 'getProduct/error';
const FILTER_PRODUCTS_BY_NAME = 'product/filterByName';
const FILTER_PRODUCTS_BY_PRICE = 'product/filterByPrice';

export default {GET_PRODUCT_REQUEST, GET_PRODUCT_SUCCESS, GET_PRODUCT_ERROR, FILTER_PRODUCTS_BY_NAME, FILTER_PRODUCTS_BY_PRICE};